import { render, staticRenderFns } from "./PopupBannerList.vue?vue&type=template&id=ee658b78&"
import script from "./PopupBannerList.vue?vue&type=script&lang=js&"
export * from "./PopupBannerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports